import { AlwaysStencilFunc, EqualStencilFunc, GreaterEqualStencilFunc, GreaterStencilFunc, LessEqualStencilFunc, LessStencilFunc, NeverStencilFunc, NotEqualStencilFunc } from 'three';

export const stencilFuncValues = {
    NeverStencilFunc,
    LessStencilFunc,
    EqualStencilFunc,
    LessEqualStencilFunc,
    GreaterStencilFunc,
    NotEqualStencilFunc,
    GreaterEqualStencilFunc,
    AlwaysStencilFunc,
};

export const stencilFuncNames: { [v: number]: StencilFunc } = {};
Object.keys(stencilFuncValues).forEach((k: StencilFunc) =>
{
    stencilFuncNames[stencilFuncValues[k]] = k;
});

export type StencilFunc = keyof typeof stencilFuncValues;
